import { render, staticRenderFns } from "./BkkRelease.vue?vue&type=template&id=1e06df50&scoped=true&"
import script from "./BkkRelease.vue?vue&type=script&lang=js&"
export * from "./BkkRelease.vue?vue&type=script&lang=js&"
import style0 from "./BkkRelease.vue?vue&type=style&index=0&id=1e06df50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e06df50",
  null
  
)

export default component.exports